import { addTranslation, setTankerProjectId } from 'react-tanker';

import { SupportedLang } from '../../../types/common';

let appLang: SupportedLang = 'ru';

/**
 * Возвращает текущий язык приложения
 *
 * @returns {SupportedLang}
 */
export const getAppLang = () => appLang;

/**
 * Инициализирует i18n в приложении
 *
 * @param {SupportedLang} [_lang]
 */
export const initI18N = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _lang?: SupportedLang
): void => {
    setTankerProjectId('telemost');

    appLang = LANG as SupportedLang;
    addTranslation(LANG, require(`../../../i18n/${LANG}`));
};
